// App configuration
export const APP_CONFIG = {
  name: import.meta.env.VITE_APP_NAME || 'ZIPTO Admin',
  version: import.meta.env.VITE_APP_VERSION || '1.0.0',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api',
  enableMockData: import.meta.env.VITE_ENABLE_MOCK_DATA === 'true',
};

// Pagination defaults
export const PAGINATION = {
  defaultPage: 1,
  defaultLimit: 10,
  limitOptions: [10, 25, 50, 100],
};

// Date formats
export const DATE_FORMATS = {
  display: 'dd MMM yyyy',
  displayWithTime: 'dd MMM yyyy, HH:mm',
  input: 'yyyy-MM-dd',
  api: "yyyy-MM-dd'T'HH:mm:ss'Z'",
};

// Status labels and colors
export const STATUS_CONFIG = {
  booking: {
    pending: { label: 'Pending', color: 'warning' },
    accepted: { label: 'Accepted', color: 'primary' },
    driver_assigned: { label: 'Driver Assigned', color: 'primary' },
    ongoing: { label: 'In Transit', color: 'primary' },
    completed: { label: 'Delivered', color: 'success' },
    cancelled: { label: 'Cancelled', color: 'destructive' },
  },
  driver: {
    active: { label: 'Active', color: 'success' },
    inactive: { label: 'Inactive', color: 'muted' },
    suspended: { label: 'Suspended', color: 'destructive' },
    pending_approval: { label: 'Pending Approval', color: 'warning' },
  },
  kyc: {
    pending: { label: 'Pending', color: 'warning' },
    approved: { label: 'Approved', color: 'success' },
    rejected: { label: 'Rejected', color: 'destructive' },
  },
  payment: {
    pending: { label: 'Pending', color: 'warning' },
    paid: { label: 'Paid', color: 'success' },
    failed: { label: 'Failed', color: 'destructive' },
    refunded: { label: 'Refunded', color: 'muted' },
  },
  ticket: {
    open: { label: 'Open', color: 'warning' },
    in_progress: { label: 'In Progress', color: 'primary' },
    resolved: { label: 'Resolved', color: 'success' },
    closed: { label: 'Closed', color: 'muted' },
  },
  priority: {
    low: { label: 'Low', color: 'muted' },
    medium: { label: 'Medium', color: 'warning' },
    high: { label: 'High', color: 'destructive' },
    urgent: { label: 'Urgent', color: 'destructive' },
  },
};

// Vehicle type config — matches the backend's VehicleType enum
export const VEHICLE_CONFIG = {
  bike: { label: 'Bike', icon: 'Bike', color: '#3B82F6' },
  scooty: { label: 'Scooty', icon: 'Bike', color: '#3B82F6' },
  auto: { label: 'Auto', icon: 'Car', color: '#10B981' },
  pickup: { label: 'Pickup', icon: 'Truck', color: '#F59E0B' },
  mini_truck: { label: 'Mini Truck', icon: 'Truck', color: '#F59E0B' },
  three_wheeler: { label: 'Three Wheeler', icon: 'Car', color: '#10B981' },
  tata_ace: { label: 'Tata Ace', icon: 'Truck', color: '#F59E0B' },
  pickup_8ft: { label: 'Pickup 8ft', icon: 'Truck', color: '#F59E0B' },
  tata_407: { label: 'Tata 407', icon: 'Truck', color: '#EF4444' },
  truck: { label: 'Truck', icon: 'Truck', color: '#EF4444' },
};

// Map configuration
export const MAP_CONFIG = {
  defaultCenter: { lat: 20.2961, lng: 85.8245 }, // Bhubaneswar
  defaultZoom: 12,
  tileLayer: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
};
